export default __webpack_public_path__ + "static/media/time.e567cc3a.gif";